import gql from 'graphql-tag';

export const MODIFY_CREDIT_CARD = gql`
  mutation ($policyId: ID!, $accountId: ID!, $basisTheoryCardToken: String!, $customerId: String!) {
    creditCard: modifyCreditCard(
      accountId: $accountId
      policyId: $policyId
      basisTheoryCardToken: $basisTheoryCardToken
      customerId: $customerId
    ) {
      last4
      brand
      id
      expMonth
      expYear
    }
  }
`;

export const ADD_CREDIT_CARD = gql`
  mutation ($policyId: ID!, $accountId: ID!, $basisTheoryCardToken: String!, $customerId: String, $isPrimary: Boolean) {
    addCreditCard(
      accountId: $accountId
      policyId: $policyId
      basisTheoryCardToken: $basisTheoryCardToken
      customerId: $customerId
      isPrimary: $isPrimary
    ) {
      success
      message
      card {
        id
        last4
        brand
        expMonth
        expYear
        customerId
      }
    }
  }
`;

export const ADD_BANK_ACCOUNT = gql`
  mutation (
    $policyId: ID!
    $accountId: ID!
    $basisTheoryBankAccountToken: String!
    $customerId: String
    $bypassMicroBiltVerification: Boolean
  ) {
    addBankAccount(
      accountId: $accountId
      policyId: $policyId
      basisTheoryBankAccountToken: $basisTheoryBankAccountToken
      customerId: $customerId
      bypassMicroBiltVerification: $bypassMicroBiltVerification
    ) {
      success
      message
      bankAccount {
        id
        last4
        bankName
        customerId
        pending
      }
    }
  }
`;

export const RUN_MANUAL_CHARGE = gql`
  mutation (
    $policyId: ID!
    $accountId: ID!
    $paymentMethod: String!
    $amount: Float!
    $internalDescription: String!
    $billType: String!
    $payAhead: Boolean
    $useSweepAccount: Boolean
    $sweepPaymentMethodId: String
  ) {
    runManualCharge(
      policyId: $policyId
      accountId: $accountId
      paymentMethod: $paymentMethod
      amount: $amount
      internalDescription: $internalDescription
      billType: $billType
      payAhead: $payAhead
      useSweepAccount: $useSweepAccount
      sweepPaymentMethodId: $sweepPaymentMethodId
    ) {
      last4
      type
      success
      error
    }
  }
`;

// Staff "Send Invoice" billing-tab action (#34203): send the policy's invoice to the insured via
// the chosen channel(s). Handled by the tools/billing lambda, so it returns a ToolResult union.
export const SEND_POLICY_INVOICE = gql`
  mutation ($args: SendPolicyInvoiceInput, $taskRunId: String!) {
    toolsSendPolicyInvoice(args: $args, taskRunId: $taskRunId) {
      ... on ToolSuccess {
        success
        details
        __typename
      }
      ... on ToolError {
        success
        error
        __typename
      }
    }
  }
`;

export const REMOVE_PAYMENT_METHOD = gql`
  mutation ($paymentMethodId: ID!, $accountId: ID!, $policyId: ID!) {
    removePaymentMethod(paymentMethodId: $paymentMethodId, policyId: $policyId, accountId: $accountId) {
      id
      brand
      last4
      bankName
      expMonth
      expYear
    }
  }
`;
